import {
    IAppointmentScheduleResponse, IDosage,
    // IFormattedAge,
    IFormattedAge, IPatientDetail, IPrescription
} from "@curefit/care-common";
import { IMetricData } from "@curefit/metrics-common";
import { IDayEpochInfo } from "../models/util/IDayEpochInfo"
import { IHourInfo } from "../models/util/IHourInfo"
import { PatientPersonalProfile } from "@curefit/ups-common";
import IGenericPlanPrescriptionDetailObject from "../models/gms/IGenericPrescriptionDetailObject";
import { DietPrescriptionItemRequest, FitnessPrescriptionItemRequest, HabitPrescriptionItemRequest, ConsultationPrescriptionItemRequest, MedicinePrescriptionItemRequest, DiagnosticPrescriptionItemRequest, PrescriptionItemGuideline, UserGoalView } from "@curefit/gmf-common";
import * as RoutesConfig from "../routes";

import * as _ from "lodash";
import * as moment from "moment";
import { IPatientVitalHistory, IPatientVitalResponse, IPatientVitalsUI } from "../models/IPatientVitalResponse"
import {
    AppConstants,
    DosageSlots,
    FoodGroupsMapping,
    UserRoles,
    ConfigConstants,
    ORION_IMG_URL,
    ALLOWED_ACTIONS,
    QuestionType,
    DoctorType,
    SHIFT_STATUS,
    toastNotificationAppearance,
    FeatureConfigValues,
    testWidgets,
    ConsultationStatusConstant
} from "./AppConstants";
import IAccountData from "../models/IAccountData";
import IConditionsUI from "../models/IConditionsUI";
import IEditedBy from "../models/IEditedBy";
import { IFitnessSchedule } from "../models/IFitnessPrescription";
import IFrequency from "../../../common/models/IFrequency";
import IStaticDataValue from "../../../common/models/IStaticDataValue";
import ISelect from "../../../common/models/ISelect";
import IMealSlot from "../models/IMealSlot";
import { IOngoingConsultation } from "../models/IOngoingConsultation";
import IPatientCondition from "../models/IPatientCondition";
import ModelFactory from "../models/ModelFactory";
import { IPrescriptionMedication, INewConfigData } from "../models/patients/IEHRSavePatientMedicalProfile";
import IPatientLifestylePlanWrapper from "../models/patients/IPatientLifestylePlanWrapper";
import { IAddMetric } from "@curefit/metrics-common";
import { CFS_API_ENDPOINT_HOST, CFS_API_ENDPOINT_PORT } from "../../../common/configs/configs";
// import PatientPersonalProfile from "../models/patients/PatientPersonalProfile";
import { BasePrescriptionItemRequest } from "@curefit/gmf-common/dist";
import { account } from "aws-sdk/clients/sns";
import { IWorkflowState, WorkflowStates } from "../../../common/models/IWorkflowState";
import { IConstituentTemplate } from "../models/PdfTemplatesModels";
import { IEHRSavePatientMedicalProfile } from "../models/patients/IEHRSavePatientMedicalProfile";
import { ITimeInterval } from "../models/Roster/ITimeInterval";
import { IRosterTimeItervals } from "../models/Roster/IRosterTimeItervals";
import { IResourceSchedule } from "../models/Roster/RosterResponse";
import * as easyScroll from "easy-scroll";
import { IFeatureConfig } from "../models/IFeatureConfig";
import { Tracker } from "./Tracker";
import { EventNames } from "./EventTrackerConstants";
import IDoctorProfile, { IAgentAttributeResponse } from "../models/IDoctorProfile";
import { get as _get, isEmpty as _isEmpty } from "lodash";
import { IAppNotificationEventData, InAppNotificationComponent } from "../components/InAppNotification";
import { store as reduxStore } from "../reducers/AllReducer";

let MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export let SHORT_MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
let WEEK_DAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
let SHORT_DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];


export enum LOADING_STATE {
    NOT_INITIALIZED,
    LOADING,
    LOADED
}


export class EpochConstants {
    static EPOCH_IN_A_SEC: number = 1000;
    static EPOCH_IN_A_MIN: number = 60 * EpochConstants.EPOCH_IN_A_SEC;
    static EPOCH_IN_AN_HOUR: number = 60 * EpochConstants.EPOCH_IN_A_MIN;
    static EPOCH_IN_AN_DAY: number = 24 * EpochConstants.EPOCH_IN_AN_HOUR;
}

export default class AppUtils {
    public static getTenant(): string {
        const tenant: string = reduxStore?.getState()?.accountData?.tenant;
        return tenant;
    }

    static addConsIdAndDocIdtoUrlParams(url: string) {
        let state = reduxStore.getState();
        let consId = state.ongoingConsultation && state.ongoingConsultation.appointmentSchedule && state.ongoingConsultation.appointmentSchedule.id;
        let doctorId = state.doctorProfile && state.doctorProfile.id;
        url = `${url}&utm_source=ORION&utm_consultation_id=${consId}&utm_doctor_id=${doctorId}`;
        return url;
    }

    static showInAppNotification(data: IAppNotificationEventData): void {
        const event: Event = new CustomEvent(InAppNotificationComponent.SHOW_NOTIFICATION_EVENT, { detail: data })
        document.dispatchEvent(event);
    }
    static dispachCustomeEvent(eventName: string, details: any) {
        const event: CustomEvent = new CustomEvent(eventName, details);
        document.dispatchEvent(event);
    }

    static getSlugUrl(doctorProfile: IDoctorProfile): string {
        const slugAttribute: IAgentAttributeResponse = doctorProfile && doctorProfile.agentAttributeResponses &&
            doctorProfile.agentAttributeResponses.find(({ attributeName }) => attributeName === "SLUG")

        const slugValue: string = slugAttribute
            ? `${slugAttribute.attributeValue}.carefit.in`
            : "";
        return slugValue;
    }

    static convert12HrsTo24HrsTimeFormat(hour: string, minute: string, meridian: string): string {
        return moment(`${hour}:${minute} ${meridian}`, ["h:mm A"]).format("HH:mm");
    }

    static getIsMobile = () => {
        let check = false;
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (
            // tslint:disable-next-line
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                userAgent
            ) || // tslint:disable-next-line
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                userAgent.substr(0, 4)
            )
        ) {
            check = true;
        }
        return check;
    };

    static createIndexedMapFromArray(objArr: any[], identityPropName: string): { [key: number]: any } {
        let hashMap: { [key: number]: any } = {};
        _.forEach(objArr, (obj: any) => {
            hashMap[obj[identityPropName]] = obj;
        });
        return hashMap;
    }

    static getTimeListInIntervals(interval: number): IRosterTimeItervals[] {
        let epoch = new Date().setHours(0, 0, 0, 0);
        const intervalList = [];
        for (let i = 0; i < 96; i++) {
            epoch = epoch + interval * 60 * 1000
            intervalList.push({
                displayText: moment(epoch).format("hh:mm a"),
                value: moment(epoch).format("HH:mm")
            });
        }
        return intervalList;
    }

    static replaceSpacesWithUnderscore(word: string): string {
        let newWord: string = word.replace(/ /g, "_");
        return newWord;
    }

    static getMonthName(monthNumber: number) {
        return MONTH_NAMES[monthNumber];
    }

    static getDayName(dayNumber: number) {
        return WEEK_DAY_NAMES[dayNumber];
    }

    static getFormattedDate(date: Date, numericOnly?: boolean) {
        if (date) {
            return (date.getDate() + "-" + numericOnly ? date.getMonth() : AppUtils.getMonthName(date.getMonth()) + "-" + date.getFullYear());
        } else {
            return "-";
        }
    }

    static getFormattedLastEditedDate(epochTime: number): string {
        let date = new Date(epochTime);
        // return date.getDate() + " " + SHORT_MONTH_NAMES[date.getMonth()] + ", " + date.getFullYear();
        return date.toString();
    }

    static getFormattedAppointmentDateTime(startTimestamp: number, endTimestamp: number) {
        let start: Date = new Date(startTimestamp);
        let end: Date = new Date(endTimestamp);
        let dateString = AppUtils.getFormattedDate(start);
        let startString = start.getHours() + ":" + start.getMinutes();
        let endString = end.getHours() + ":" + end.getMinutes();
        return dateString + "     " + startString + " - " + endString;
    }

    static convertToTwoDigitNumber(num: number) {
        return ("00" + String(num)).slice(-2);
    }

    static getHourSplitOfDay = (): IHourInfo[] => {
        let timeSplits = [], meridien = "AM";
        let epochInHalfHour = EpochConstants.EPOCH_IN_AN_HOUR / 2;
        for (let i = 0; i < 24; i++) {
            timeSplits.push({
                offset: i * epochInHalfHour,
                meridien: meridien,
                display: Math.floor(i / 2) + ":" + (i % 2 === 0 ? "00" : "30")
            })
        }
        meridien = "PM";
        for (let i = 0; i < 24; i++) {
            let hourDisplay = Math.floor(i / 2) < 1 ? "12" : Math.floor(i / 2);
            let display = hourDisplay + ":" + (i % 2 === 0 ? "00" : "30");
            timeSplits.push({ offset: (24 + i) * epochInHalfHour, meridien: meridien, display })
        }
        return timeSplits;
    }

    static getTodaysEpoch = (): IDayEpochInfo => {
        let start = new Date();
        start.setHours(0, 0, 0, 0);
        return { startEpoch: start.getTime(), endEpoch: start.getTime() + EpochConstants.EPOCH_IN_AN_DAY, display: "" };
    }

    static getDayEpochInfo = (epoch: number): IDayEpochInfo => {
        let start = new Date(epoch);
        start.setHours(0, 0, 0, 0);
        let monthText = SHORT_MONTH_NAMES[start.getMonth()];
        return {
            startEpoch: start.getTime(),
            endEpoch: start.getTime() + EpochConstants.EPOCH_IN_AN_DAY,
            display: "",
            dateText: start.getDate().toString(),
            month: monthText,
            year: start.getFullYear().toString()
        };
    }

    static getEpochFromDateAndTime(epochInMs: number, timeInHHMM: string): number {
        const [hour, min] = timeInHHMM.split(":");
        return new Date(epochInMs).setHours(Number(hour), Number(min), 0, 0);
    }

    static isOverLappingShiftsPresent(date: number, shifts: ITimeInterval[]) {
        const intervalsInEpoch = shifts.map(({ startTime, endTime }) => {
            return {
                startTime: this.getEpochFromDateAndTime(date, startTime),
                endTime: this.getEpochFromDateAndTime(date, endTime)
            }
        });
        intervalsInEpoch.sort((a, b) => a.startTime - b.startTime);
        for (let count = 0; count < intervalsInEpoch.length; count++) {
            if (intervalsInEpoch[count + 1]) {
                const startEpochOfExisitingShift = intervalsInEpoch[count].startTime;
                const endEpochOfExisitingShift = intervalsInEpoch[count].endTime;
                const startEpochOfShiftToCheck = intervalsInEpoch[count + 1].startTime;
                const endEpochOfShiftToCheck = intervalsInEpoch[count + 1].endTime;
                if ((startEpochOfShiftToCheck >= startEpochOfExisitingShift && startEpochOfShiftToCheck <= endEpochOfExisitingShift)
                    || (endEpochOfShiftToCheck >= startEpochOfExisitingShift && endEpochOfShiftToCheck <= endEpochOfExisitingShift))
                    return true;
            }

        }
        return false;

    }

    static isRosterValid(date: number, shifts: ITimeInterval[]): string {
        for (let shiftCount = 0; shiftCount < shifts.length; shiftCount++) {
            const startTime: number = this.getEpochFromDateAndTime(date, shifts[shiftCount].startTime);
            const endTime: number = this.getEpochFromDateAndTime(date, shifts[shiftCount].endTime)
            if (endTime < startTime) {
                return AppConstants.ROSTER_MESSAGES.INVALID_INTERVAL;
            }
            if (startTime === endTime) {
                return AppConstants.ROSTER_MESSAGES.SAME_TIME;
            }
        }
        return null;

    }

    static isLateNightShift(shifts: any[]) {
        const preferredStartTime = moment('7:00a', "HH:mm a");
        const preferredEndTime = moment('11:00p', "HH:mm a");
        for (let shiftCount = 0; shiftCount < shifts.length; shiftCount++) {
            if (shifts[shiftCount].startTime && shifts[shiftCount].endTime) {
                if (!(moment(shifts[shiftCount].startTime, "HH:mm").isBetween(preferredStartTime, preferredEndTime, null, '[]') && moment(shifts[shiftCount].endTime, "HH:mm").isBetween(preferredStartTime, preferredEndTime, null, '[]')))
                    return true;
            }
        }
        return false;
    }

    static isAllShiftPresent(workingDayDate: number, shifts: ITimeInterval[]): boolean {
        for (let shiftCount = 0; shiftCount < shifts.length; shiftCount++) {
            if (!shifts[shiftCount].startTime) {
                return false;
            }
            if (!shifts[shiftCount].endTime) {
                return false;
            }
        }
        return true;
    }

    static getListOfDays = (startEpoch: number, endEpoch: number): IDayEpochInfo[] => {
        let daysList: IDayEpochInfo[] = [], currDayEpoch = startEpoch;
        while (currDayEpoch < endEpoch) {
            let currDate = new Date(currDayEpoch);
            let monthText = SHORT_MONTH_NAMES[currDate.getMonth()];
            let monthDisplayText = currDate.getDate() + " " + monthText;
            daysList.push({
                startEpoch: currDayEpoch,
                endEpoch: currDayEpoch + EpochConstants.EPOCH_IN_AN_DAY,
                dateText: currDate.getDate().toString(),
                display: monthDisplayText,
                dayOfWeek: AppUtils.getDayName(currDate.getDay()),
                month: monthText,
                dayShortForm: SHORT_DAY_NAMES[currDate.getDay()]
            });
            currDayEpoch = currDayEpoch + EpochConstants.EPOCH_IN_AN_DAY;
        }
        return daysList;
    }

    static getEndDateEpochForRange = (startEpoch: number, dateRange: number) => {
        return startEpoch + (dateRange - 1) * EpochConstants.EPOCH_IN_AN_DAY;
    };

    static getStartOFDayEpoch = (epoch: number) => {
        let currDate = new Date(epoch);
        currDate.setHours(0, 0, 0, 0);
        return currDate.getTime();
    };

    static getEndOFDayEpoch = (epoch: number) => {
        let currDate = new Date(epoch);
        currDate.setHours(23, 59, 59, 999);
        return currDate.getTime();
    };

    static createDummyAppointments = (appointments: IAppointmentScheduleResponse[], numOfDays: number) => {
        let finalAppointments = $.extend(true, [], appointments);
        for (let i = 0; i < appointments.length; i++) {
            _.times(numOfDays, function (index: number) {
                let newAppointment = $.extend(true, {}, appointments[i]);
                newAppointment.startTime += index * EpochConstants.EPOCH_IN_AN_DAY;
                newAppointment.endTime += index * EpochConstants.EPOCH_IN_AN_DAY;
                finalAppointments.push(newAppointment);
            })
        }
        let moreAppointments = [];
        for (let i = 0; i < finalAppointments.length; i++) {
            let newAppointment = $.extend(true, {}, finalAppointments[i]);
            newAppointment.startTime += EpochConstants.EPOCH_IN_AN_HOUR;
            newAppointment.endTime += EpochConstants.EPOCH_IN_AN_HOUR;
            moreAppointments.push(newAppointment);
        }
        return finalAppointments.concat(moreAppointments);
    }
    static getHourMinuteFormattedDate = (epochTime: number | string) => {
        let currDate = new Date(epochTime);
        return moment(epochTime).format("HH:mm");
        // return currDate.getHours() + ":" + currDate.getMinutes();
    }

    static getConsultationUrl = (patientId: number, appointmentId: number): string => {
        let consultationUrl = RoutesConfig.PATIENT_CONSULTATION_DETAILS;
        consultationUrl = consultationUrl.replace(RoutesConfig.ROUTE_PARAMS_SEPARATOR + RoutesConfig.PATIENT_ID_PARAM, patientId.toString());
        consultationUrl = consultationUrl.replace(RoutesConfig.ROUTE_PARAMS_SEPARATOR + RoutesConfig.CONSULTATION_ID_PARAM, appointmentId.toString());
        return consultationUrl;
    };

    static getPatientConsultationsUrl = (patientId: number): string => {
        let patientUrl = RoutesConfig.PATIENT_CONSULTATIONS;
        patientUrl = patientUrl.replace(RoutesConfig.ROUTE_PARAMS_SEPARATOR + RoutesConfig.PATIENT_ID_PARAM, patientId.toString());
        return patientUrl;
    };

    static getPatienTransfomrUrl = (patientId: number): string => {
        let patientUrl = RoutesConfig.PATIENT_TRANSFORM;
        patientUrl = patientUrl.replace(RoutesConfig.ROUTE_PARAMS_SEPARATOR + RoutesConfig.PATIENT_ID_PARAM, patientId.toString());
        return patientUrl;
    };

    static getOngoingConsultationUrl = (patientId: number, appointmentId: number): string => {
        let consultationUrl = RoutesConfig.ONGOING_CONSULTATION_PATH;
        consultationUrl = consultationUrl.replace(RoutesConfig.ROUTE_PARAMS_SEPARATOR + RoutesConfig.PATIENT_ID_PARAM, patientId.toString());
        consultationUrl = consultationUrl.replace(RoutesConfig.ROUTE_PARAMS_SEPARATOR + RoutesConfig.CONSULTATION_ID_PARAM, appointmentId.toString());
        return consultationUrl;
    };

    static getRelativeDay = (time: any, defaultFormat: string, showTimeIfToday = false) => {
        let format = defaultFormat !== "" ? defaultFormat : "Do MMM, YYYY";
        if (moment(time).startOf("day").diff(moment().startOf("day"), "days") === 0) {
            if (showTimeIfToday) {
                return moment(time).format(format);
            } else {
                return AppConstants.RelativeDayLabelConstant.TODAY;
            }
        } else if (moment(time).diff(moment().subtract(1, "day"), "days") === -1) return AppConstants.RelativeDayLabelConstant.YESTERDAY;
        else if (moment(time).diff(moment().subtract(1, "day"), "days") === 1) return AppConstants.RelativeDayLabelConstant.TOMORROW;
        else return moment(time).format(format);
    }

    static getLastEditedEpochForVital = (patientVitalResponses: IPatientVitalResponse[]): number => {
        let retLastEditedDate: number = -1;
        for (let key in patientVitalResponses) {
            let patientVitalResponse = patientVitalResponses[key];
            let currLastEditedDate = AppUtils.sortPatientVitalHistory(patientVitalResponse.vitalHistoryList)[0].recordDate;
            if (currLastEditedDate > retLastEditedDate) {
                retLastEditedDate = currLastEditedDate;
            }
        }
        return retLastEditedDate;
    }

    static sortPatientVitalHistory = (patientVitalHistory: IPatientVitalHistory[]): IPatientVitalHistory[] => {
        return patientVitalHistory.sort((a: IPatientVitalHistory, b: IPatientVitalHistory) => {
            return b.recordDate - a.recordDate
        });
    }

    static isDoctor = (account: IAccountData) => {
        let roles = account.memberships;
        let doctorRole = roles.filter(role => [UserRoles.DOCTOR, UserRoles.ADMIN].includes(role.roleName as any));
        if (doctorRole.length > 0) return true;
        else return false;
    }

    static isNurse = (account: IAccountData) => {
        let roles = account.roles;
        let nurseRole = roles.filter(role => role.roleName === UserRoles.NURSE);
        if (nurseRole.length > 0) return true;
        else return false;
    }

    static getEditedBy = (account: IAccountData): IEditedBy => {
        let editedBy: IEditedBy;
        if (AppUtils.isDoctor(account)) editedBy = { id: account.id.toString(), role: UserRoles.DOCTOR }
        else if (AppUtils.isNurse(account)) editedBy = { id: account.id.toString(), role: UserRoles.DOCTOR }
        return editedBy;
    }

    // CAUTION: Dont delete it for now,
    // could be helpful in future user cases
    static getUserIdForDoctor = (account: IAccountData) => {
        let roles = account.memberships;
        let doctorRole = roles.filter(role => role.roleName === UserRoles.DOCTOR);
        if (doctorRole.length > 0) return doctorRole[0].userId;
    }

    static getDoctorEmail = (account: IAccountData): string => {
        return account.email;
    };

    static convertListToUIPastConditions = (list: IPatientCondition[]) => {
        let convertedList: IConditionsUI[] = [];
        let traversedItems: string[] = [];
        _.map(list, (listItem, index) => {
            if (traversedItems.indexOf(listItem.displayValue) === -1) {
                let items = list.filter(item => item.displayValue === listItem.displayValue)
                convertedList.push({ name: listItem.displayValue, items })
                traversedItems.push(listItem.displayValue);
            }
        })
        return convertedList;
    }

    static convertUIPastConditionsToList = (uiPastConditions: IConditionsUI[]): IPatientCondition[] => {
        let convertedList: IPatientCondition[] = [];
        _.map(uiPastConditions, (listItem) => {
            _.map(listItem.items, (item) => {
                convertedList.push(item);
            })
        })
        return convertedList;
    }

    static getYearsArrayFromPatientAge = (age?: number) => {
        let years = [];
        let currentYear = new Date().getFullYear();
        let startYear = currentYear - 100;
        if (age !== undefined) {
            startYear = currentYear - (age);
        }
        for (let i = currentYear; i > startYear; i--) {
            years.push(i);
        }
        return years;
    }

    static generateFrequencyListItems = (list: ISelect[]) => {
        let frequencyList: IStaticDataValue[] = [];
        _.map(list, (item, key) => {
            let medicineFrequency = ModelFactory.createNewStaticItem();
            medicineFrequency.internalValue = item.internalValue;
            medicineFrequency.displayValue = item.displayValue;
            frequencyList.push(medicineFrequency);
        })
        return frequencyList;
    }

    static generateBPRange = (isSystolic?: boolean) => {
        let i = isSystolic ? 70 : 40;
        let j = isSystolic ? 190 : 100;
        let staticDataValues: IStaticDataValue[] = []
        for (i; i <= j; i++) {
            let staticData: IStaticDataValue = { displayValue: i.toString(), internalValue: i.toString() }
            staticDataValues.push(staticData)
        }
        return staticDataValues;
    }

    static getSpecialityNameFromCode = (specialityCode: string, allSpecialities: any): string => {
        let name = specialityCode;
        _.map(allSpecialities, (value, key) => {
            if (specialityCode === value.doctorTypeCode) {
                name = value.displayText;
                return false;
            }
        })
        return name;
    }

    static formatPDFPages = (data: any, containerNode: any, maxHeight: number, defaultComponentGapSize: number) => {
        // Assumption - no sub-section child will be greater then max-height
        let dataObj: { [index: string]: any } = { ...data };
        let updatedList: any[] = [];
        let heightOffset = 0, currHeight = 0;
        let updatedObj: any = {};

        let formatChildNode = (parentId: string, index: number, childNodeHeight: number) => {
            currHeight += childNodeHeight;
            if (currHeight <= maxHeight) {
                heightOffset = currHeight;
                let subSecNode = updatedObj[parentId] ? [...updatedObj[parentId]] : [];
                updatedObj[parentId] = [...subSecNode, dataObj[parentId][index]];
                return;
            } else {
                updatedList.push(updatedObj);
                updatedObj = {};
                currHeight = defaultComponentGapSize, heightOffset = defaultComponentGapSize;
                formatChildNode(parentId, index, childNodeHeight);
            }
        }

        let formatNodes = (element: any) => {
            currHeight += element.clientHeight;
            if (currHeight <= maxHeight) {
                heightOffset = currHeight;
                if (dataObj[element.id]) {
                    updatedObj[element.id] = dataObj[element.id];
                }
            } else if (!dataObj[element.id].length) {
                updatedList.push(updatedObj);
                updatedObj = {};
                currHeight = defaultComponentGapSize, heightOffset = defaultComponentGapSize;
                formatNodes(element);
            } else {
                let id = element.id;
                let subSecId = id + "-subsection";
                let subsectionNode = document.getElementById(subSecId);
                if (subsectionNode && subsectionNode.children && subsectionNode.children.length > 0) {
                    currHeight = heightOffset + defaultComponentGapSize;
                    _.map(subsectionNode.children, (nodeItem: any, index: number) => {
                        formatChildNode(element.id, index, nodeItem.clientHeight);
                    })
                }
            }
        }

        if (containerNode.children && containerNode.children.length > 0) {

            _.map(containerNode.children, (element: any) => {
                formatNodes(element)
            })
        }
        updatedList.push(updatedObj);
        return updatedList;
    }

    static arrangeDosageArray = (dosage: IDosage[]) => {
        let rearrangedDosageArray: IDosage[] = [];
        if (!_.isEmpty(dosage)) {
            if (dosage.filter(item => item.slot === DosageSlots.BREAKFAST).length) rearrangedDosageArray.push(dosage.filter(item => item.slot === DosageSlots.BREAKFAST)[0])
            if (dosage.filter(item => item.slot === DosageSlots.LUNCH).length) rearrangedDosageArray.push(dosage.filter(item => item.slot === DosageSlots.LUNCH)[0])
            if (dosage.filter(item => item.slot === DosageSlots.DINNER).length) rearrangedDosageArray.push(dosage.filter(item => item.slot === DosageSlots.DINNER)[0])
            return rearrangedDosageArray;
        } else {
            return dosage;
        }
    }

    static getAgeFromRecordedAge = (recordedAge: number, recordedDate: any) => {
        let recordedDt: any = new Date(recordedDate)
        let currentDate: any = new Date();
        let patientAge = recordedAge + moment.duration(currentDate - recordedDt).years();
        return patientAge;
    }

    static getRecentVitals = (vitals: IPatientVitalResponse[], maxDays?: number) => {
        let currDate = new Date().getDate();
        let currDateEpoch = new Date().getTime();
        let currVitals: any[] = [];
        let daysBuffer = maxDays !== undefined ? maxDays : 0;
        _.map(vitals, (vital, index: number) => {
            if (vital.vitalHistoryList && vital.vitalHistoryList.length) {
                let latestVital = vital.vitalHistoryList[0]
                _.map(vital.vitalHistoryList, (history, index) => {
                    if (latestVital.recordDate < history.recordDate) {
                        latestVital = history;
                    }
                })
                let difference = Math.abs(moment(currDateEpoch).diff(moment(latestVital.recordDate), "days"));
                if (difference <= daysBuffer) {
                    let todayVital: any = { ...vital };
                    delete todayVital.vitalHistoryList;
                    todayVital.vital = latestVital;
                    currVitals.push(todayVital);
                }
            }
        })
        return AppUtils.getCombinedVitals(currVitals);
    }

    static getCombinedVitals = (currentVitals: IPatientVitalsUI[]): IPatientVitalsUI[] => {
        if (_.isEmpty(currentVitals)) return [];
        let allVitals = [...currentVitals];
        let diastolicValue = null, systolicValue = null;
        let newVital: IPatientVitalsUI = null;
        if (!_.isEmpty(allVitals)) {
            const diastolicVital = allVitals.find((vitalItem) => vitalItem.vitalName === "diastolic bp");
            const systolicVital = allVitals.find((vitalItem) => vitalItem.vitalName === "systolic bp");
            diastolicValue = AppUtils.isDefined(diastolicVital) && !_.isEmpty(diastolicVital.vital) ? diastolicVital.vital.value : null;
            systolicValue = AppUtils.isDefined(systolicVital) && !_.isEmpty(systolicVital.vital) ? systolicVital.vital.value : null;
            newVital = !_.isEmpty(diastolicVital)
                ?
                ModelFactory.createNewPatientUIVitals(diastolicVital.avgValue, diastolicVital.unit, "combined bp", null, diastolicVital.vital.recordDate)
                :
                !_.isEmpty(systolicVital)
                    ?
                    ModelFactory.createNewPatientUIVitals(systolicVital.avgValue, systolicVital.unit, "combined bp", null, systolicVital.vital.recordDate)
                    :
                    null
        }
        if (AppUtils.isDefined(newVital)) {
            const hasDiastolicValue = AppUtils.isDefined(diastolicValue);
            const hasSystolicValue = AppUtils.isDefined(systolicValue);
            if (hasDiastolicValue && hasSystolicValue)
                newVital.vital.value = `${systolicValue}/${diastolicValue}`;
            else if (!hasDiastolicValue && hasSystolicValue)
                newVital.vital.value = `${systolicValue}/-`;
            else if (hasDiastolicValue && !hasSystolicValue)
                newVital.vital.value = `-/${diastolicValue}`;
            else
                newVital.vital.value = `-`;

            allVitals.push(newVital);
            return allVitals.filter(item => !(item.vitalName === "diastolic bp" || item.vitalName === "systolic bp" || item.vitalName === "bp"))
        } else {
            return allVitals;
        }
    }

    static formatSlots = (slot: string) => {
        let formattedString = "";
        let slotArr = slot.split("-")
        if (slotArr.length > 1) {
            slotArr = slotArr.map((char: string, index: number) => {
                if (char === "1") {
                    return ["Morning", "Afternoon", "Night"][index]
                }
            }).filter((item: string) => item);
        }
        formattedString += slotArr.join(", ");
        return formattedString;
    }

    static getSlotTextFromSlotBreakup = (slots: IDosage[]) => {
        let slotArray = [];
        slotArray.push(slots.filter(item => item.slot === "BREAKFAST").length > 0 ? slots.filter(item => item.slot === "BREAKFAST")[0].quantity : 0);
        slotArray.push(slots.filter(item => item.slot === "LUNCH").length > 0 ? slots.filter(item => item.slot === "LUNCH")[0].quantity : 0);
        slotArray.push(slots.filter(item => item.slot === "DINNER").length > 0 ? slots.filter(item => item.slot === "DINNER")[0].quantity : 0);
        return slotArray.join("-");
    }

    static toCapitalize = (word: string) => {
        let updatedWord = word.toLowerCase();
        let newWord = updatedWord.charAt(0).toUpperCase() + updatedWord.slice(1);
        return newWord;
    }

    static internalToDisplayValue = (word: string) => {
        let updatedWord = word.toLowerCase();
        let newWord = updatedWord.charAt(0).toUpperCase() + updatedWord.slice(1);
        return newWord.split("_").join(" ");
    }

    static getSystemicExamDisplayValuesFromInternalValues = (internalValueList: string[], examsList: IStaticDataValue[]): string[] => {
        let displayValueArray: string[] = [];
        _.map(internalValueList, (internalValue: string) => {
            let filteredExams = examsList.filter(item => item.internalValue === internalValue);
            if (filteredExams.length) {
                displayValueArray.push(filteredExams[0].displayValue);
            }
        })
        return displayValueArray;
    }

    static generateMonthItems(items: any, showFullName: boolean): IStaticDataValue[] {
        let staticDataValues: IStaticDataValue[] = [];
        _.map(items, (month, key) => {
            let staticDataItem = ModelFactory.createNewStaticItem();
            staticDataItem.internalValue = key;
            staticDataItem.displayValue = showFullName ? month : month.substring(0, 3);
            staticDataValues.push(staticDataItem)
        })
        return staticDataValues;
    }

    static generateYearItems(year: number, startEnd: string): IStaticDataValue[] {
        let staticDataValues: IStaticDataValue[] = [];
        let years = AppUtils.getYearsArrayFromPatientAge();
        if (startEnd === "START" && year !== null) years = years.filter(item => item <= year);
        else if (startEnd === "END" && year !== null) years = years.filter(item => item >= year);
        _.map(years, (year) => {
            let staticDataItem = ModelFactory.createNewStaticItem();
            staticDataItem.internalValue = year.toString();
            staticDataItem.displayValue = year.toString();
            staticDataValues.push(staticDataItem)
        });
        return staticDataValues;
    }

    /* Time Picker Utilities */

    // this method accepts time in HH:MM format. AM/PM is determined by HH
    static getTimeInSeconds = (time: string) => {
        let timeInSeconds = null;
        let splitArray = time.split(":");
        if (splitArray.length === 2) {
            let hour = parseInt(splitArray[0]);
            let minutes = parseInt(splitArray[1]);
            timeInSeconds = (hour * 3600) + (minutes * 60)
        }
        return timeInSeconds;
    }

    // this method returns time in HH:MM format from the format returned by the previous method
    static getReadableTimeFromSeconds = (time: number) => {
        let readableTime = ""
        if (time !== undefined && time !== null && time.toString() !== "") {
            let hours = parseInt((time / 3600).toString()).toString();
            hours = hours.toString().length === 2 ? hours : "0" + hours;    // ensuring hours is in two digits
            let minutes = parseInt(((time % 3600) / 60).toString()).toString();
            minutes = minutes.toString().length === 2 ? minutes : "0" + minutes;    // ensuring minutes is in two digits
            readableTime = `${hours}:${minutes}`;
        }
        return readableTime;
    }
    /* End of Time Picker Utilities */

    static getTimeInHoursFromSeconds = (timeInSeconds: number) => {
        let timeToReturn = null;
        if (timeInSeconds !== undefined && timeInSeconds !== null && timeInSeconds.toString() !== "") {
            timeToReturn = (timeInSeconds / 60) / 60;
        }
        return timeToReturn;
    }


    static getTimeInDecimalHoursFromSeconds = (timeInSeconds: number) => {
        let timeToReturn = null;
        if (timeInSeconds !== undefined && timeInSeconds !== null && timeInSeconds.toString() !== "") {
            timeToReturn = `${parseInt((timeInSeconds / 3600) + "")}.${((timeInSeconds % 3600) / 60)}`;
        }
        return timeToReturn;
    }

    static getTimeInDecimalMinutesFromSeconds = (timeInSeconds: number) => {
        let timeToReturn = null;
        if (timeInSeconds !== undefined && timeInSeconds !== null && timeInSeconds.toString() !== "") {
            timeToReturn = `${parseInt((timeInSeconds / 60) + "")}.${(timeInSeconds % 60)}`;
        }
        return timeToReturn;
    }

    static getTimeInSecondsFromMinutes = (time: string) => {
        let timeInSeconds = null;
        let splitArray = time.split(".");
        let minutes = splitArray[0] ? parseInt(splitArray[0]) : 0;
        let seconds = splitArray[1] ? parseInt(splitArray[1]) : 0;
        timeInSeconds = (minutes * 60) + seconds
        return timeInSeconds.toString();
    }

    static getTimeInSecondsFromHours = (time: string) => {
        let timeInSeconds = null;
        let splitArray = time.split(".");
        let hours = splitArray[0] ? parseInt(splitArray[0]) : 0;
        let minutes = splitArray[1] ? parseInt(splitArray[1]) : 0;
        timeInSeconds = (hours * 3600) + (minutes * 60)
        return timeInSeconds.toString();
    }

    static getFetchUnreadMessageFromTime = () => {
        return (new Date().getTime() - (EpochConstants.EPOCH_IN_AN_DAY * AppConstants.UNREAD_MESSAGE_FOR_NUMBER_OF_DAYS));
    }

    static getFetchUnreadMessageToTime = () => {
        return (new Date().getTime() + (EpochConstants.EPOCH_IN_A_MIN * AppConstants.UNREAD_MESSAGE_TO_TIME_RECONCILIATION_IN_MINUTES));
    }

    static sanitizeRequestItemBeforeSave = (item: any) => {
        let sanitizedItem = { ...item };
        if (sanitizedItem.id !== undefined) delete sanitizedItem.id;
        if (sanitizedItem.createdAt !== undefined) delete sanitizedItem.createdAt;
        if (sanitizedItem.updatedAt !== undefined) delete sanitizedItem.updatedAt;
        return sanitizedItem;
    }

    static getConsultationTypeImageUrl = (consultation: IAppointmentScheduleResponse) => {
        if (consultation.consultationProduct.subServiceType === "LC") return ORION_IMG_URL + "icons/lc-consult.svg";
        else return ORION_IMG_URL + "icons/doctor-consult.svg";
    }

    static isManagedGoalConsultation = (appointmentSchedule: IAppointmentScheduleResponse) => {
        return !_.isEmpty(appointmentSchedule) &&
            !_.isEmpty(appointmentSchedule.rootBooking) &&
            (appointmentSchedule.rootBooking.subCategoryCode === "MP" || appointmentSchedule.rootBooking.subCategoryCode === "MP_V2" || appointmentSchedule.rootBooking.subCategoryCode === "MIND_THERAPY");
    }

    static isLifeStyleConsultation = (appointmentSchedule: IAppointmentScheduleResponse) => {
        return !_.isEmpty(appointmentSchedule) &&
            !_.isEmpty(appointmentSchedule.consultationSellableProduct) &&
            !_.isEmpty(appointmentSchedule.consultationSellableProduct.consultationProduct) &&
            appointmentSchedule.consultationSellableProduct.consultationProduct.subServiceType === "LC";
    }

    static isMindConsultation = (appointmentSchedule: IAppointmentScheduleResponse) => {
        return !_.isEmpty(appointmentSchedule) &&
            !_.isEmpty(appointmentSchedule.consultationSellableProduct) &&
            !_.isEmpty(appointmentSchedule.consultationSellableProduct.consultationProduct) &&
            (appointmentSchedule.consultationSellableProduct.consultationProduct.subServiceType === DoctorType.MIND_THERAPIST || (appointmentSchedule.consultationSellableProduct.consultationProduct.subServiceType === DoctorType.EFA));
    }

    static isAILCConsultation = (appointmentSchedule: IAppointmentScheduleResponse) => {
        return !_.isEmpty(appointmentSchedule) &&
            !_.isEmpty(appointmentSchedule.consultationProduct) &&
            !_.isEmpty(appointmentSchedule.consultationProduct.subServiceType) &&
            appointmentSchedule.consultationProduct.subServiceType === "AI_LC";
    }

    static isDoctorConsultation = (appointmentSchedule: IAppointmentScheduleResponse) => {
        return !_.isEmpty(appointmentSchedule)
            && !_.isEmpty(appointmentSchedule.consultationProduct)
            && !_.isEmpty(appointmentSchedule.consultationProduct.subServiceType)
            && appointmentSchedule.consultationProduct.subServiceType !== "AI_LC"
            && appointmentSchedule.consultationProduct.subServiceType !== DoctorType.MIND_THERAPIST
            && appointmentSchedule.consultationProduct.subServiceType !== DoctorType.PHYSIOTHERAPIST
            && appointmentSchedule.consultationProduct.subServiceType !== DoctorType.EFA
            && appointmentSchedule.consultationProduct.subServiceType !== "LC";
    }

    static getFoodGroupsIdFromList = (foodgroups: string[]) => {
        let foodGroupsId = "";
        _.map(FoodGroupsMapping, (items: string[], key: string) => {
            if (!_.isEmpty(items) && _.isEqual(items.sort(), foodgroups.sort())) {
                foodGroupsId = key;
                return false;
            }
        })
        return foodGroupsId;
    }

    static calculateTotalCaloriesInADay = (meals: IMealSlot[]) => {
        let totalCalories = 0;
        _.map(meals, (meal: IMealSlot) => {
            totalCalories += parseInt(meal.details.calories.toString());
        })
        return totalCalories;
    }

    static sortMealsByTime = (meals: IMealSlot[]): IMealSlot[] => {
        return meals.sort(function (o1: IMealSlot, o2: IMealSlot) {
            let time1 = new Date("1970/01/01 " + o1.recommendedTimeOfDay) as any;
            let time2 = new Date("1970/01/01 " + o2.recommendedTimeOfDay) as any;
            return time1 - time2;
        })
    }

    static getVitalIcon = (vital: string) => {
        switch (vital) {
            case "HEIGHT":
                return ORION_IMG_URL + "icons/vital-height.svg"
            case "WEIGHT":
                return ORION_IMG_URL + "icons/vital-weight.svg"
            case "SPO2":
                return ORION_IMG_URL + "icons/vital-spo2.svg"
            case "BP":
            case "COMBINED BP":
                return ORION_IMG_URL + "icons/vital-bp.svg"
            case "SYSTOLIC BP":
                return ORION_IMG_URL + "icons/vital-bp.svg"
            case "DIASTOLIC BP":
                return ORION_IMG_URL + "icons/vital-bp.svg"
            case "RESPIRATORY RATE":
                return ORION_IMG_URL + "icons/vital-rr.svg"
            case "TEMPERATURE":
                return ORION_IMG_URL + "icons/vital-temperature.svg"
            case "BMI":
                return ORION_IMG_URL + "icons/vital-bmi.svg"
            case "WAIST":
                return ORION_IMG_URL + "icons/vital-waist.svg"
            case "HIP":
                return ORION_IMG_URL + "icons/vital-hip.svg"
            case "WHR":
                return ORION_IMG_URL + "icons/vital-whr.svg"
            case "PULSE RATE":
                return ORION_IMG_URL + "icons/vital-pr.svg"
            default:
                return ORION_IMG_URL + "icons/vital-spo2.svg"
        }
    }

    static formatPatientPlan = (patientPlan: IGenericPlanPrescriptionDetailObject[], doctorPrescription?: IPrescription, therapistPrescription?: IPrescription) => {
        let plan: IPatientLifestylePlanWrapper = {} as IPatientLifestylePlanWrapper;
        patientPlan = patientPlan.filter(item => !_.isNull(item));
        if (patientPlan.filter(item => item.category === "FOOD").length > 0) {
            // plan.dietPrescription = patientPlan.filter(item => item.category === "FOOD" && (_.isEmpty(item.editInfo) || item.editInfo.nextStatus !== AppConstants.planStatus.CANCELLED)) as IDietPlanPrescriptionItem[];
            // Cannot do the above. Since, if we filter out CANCELLED items, when we finally save the plan, the cancelled prescription items won't be sent(as we filtered them out here) and they'll remain in LIVE state
            plan.dietPrescription = patientPlan.filter(item => item.category === "FOOD") as DietPrescriptionItemRequest[];
            if (!_.isEmpty(plan.dietPrescription)) plan.dietPrescription.forEach(item => delete (item as any).version);
        }
        if (patientPlan.filter(item => item.category === "FITNESS").length > 0) {
            plan.fitnessPrescription = patientPlan.filter(item => item.category === "FITNESS") as FitnessPrescriptionItemRequest[];
        }
        if (patientPlan.filter(item => item.category === "MIND").length > 0) {
            plan.mindfulnessPrescription = patientPlan.filter(item => item.category === "MIND") as FitnessPrescriptionItemRequest[];
        }

        if (patientPlan.filter(item => item.category === "HABIT").length > 0) {
            plan.habitsPrescription = patientPlan.filter(item => item.category === "HABIT") as HabitPrescriptionItemRequest[];
        }

        // consultations data for DOCTOR type
        if (patientPlan.filter(item => item.category === "CONSULTATION" && !_.isEmpty(item.source) && item.source.sourceFamily === AppConstants.MPDoctorTypes.DOCTOR).length > 0) {
            plan.consultations = patientPlan.filter(item => item.category === "CONSULTATION" && !_.isEmpty(item.source) && item.source.sourceFamily === AppConstants.MPDoctorTypes.DOCTOR) as ConsultationPrescriptionItemRequest[];
        }
        // consultations data for THERAPIST type
        if (patientPlan.filter(item => item.category === "CONSULTATION" && !_.isEmpty(item.source) && AppUtils.isMindDoctor(item.source.sourceFamily)).length > 0) {
            plan.consultationsByTherapist = patientPlan.filter(item => item.category === "CONSULTATION" && !_.isEmpty(item.source) && AppUtils.isMindDoctor(item.source.sourceFamily)) as ConsultationPrescriptionItemRequest[];
        }
        // consultations data for LIFESTYLE type
        // If source is empty, then it's a new prescription item saved in redis, and it's an LC consultation, since save in draft is only supported in LC consultation
        if (patientPlan.filter(item => item.category === "CONSULTATION" && (_.isEmpty(item.source) || item.source.sourceFamily === AppConstants.MPDoctorTypes.LIFESTYLE)).length > 0) {
            plan.consultationsByLifestyleCoach = patientPlan.filter(item => item.category === "CONSULTATION" && (_.isEmpty(item.source) || item.source.sourceFamily === AppConstants.MPDoctorTypes.LIFESTYLE)) as ConsultationPrescriptionItemRequest[];
        }

        // medicine data for DOCTOR type
        if (patientPlan.filter(item => item.category === "MEDICINE" && item.source.sourceFamily === AppConstants.MPDoctorTypes.DOCTOR).length > 0) {
            plan.medicinePlanPrescription = patientPlan.filter(item => item.category === "MEDICINE" && item.source.sourceFamily === AppConstants.MPDoctorTypes.DOCTOR) as MedicinePrescriptionItemRequest[];
        }
        // medicine data for THERAPIST type
        if (patientPlan.filter(item => item.category === "MEDICINE" && !_.isEmpty(item.source) && AppUtils.isMindDoctor(item.source.sourceFamily)).length > 0) {
            plan.medicinePlanPrescriptionByTherapist = patientPlan.filter(item => item.category === "MEDICINE" && AppUtils.isMindDoctor(item.source.sourceFamily)) as MedicinePrescriptionItemRequest[];
        }

        // diagnostic data for DOCTOR type
        if (patientPlan.filter(item => item.category === "DIAGNOSTICS" && item.source.sourceFamily === AppConstants.MPDoctorTypes.DOCTOR).length > 0) {
            plan.diagnosticAssessment = patientPlan.filter(item => item.category === "DIAGNOSTICS" && item.source.sourceFamily === AppConstants.MPDoctorTypes.DOCTOR) as DiagnosticPrescriptionItemRequest[];
        }
        // diagnostic data for THERAPIST type
        if (patientPlan.filter(item => item.category === "DIAGNOSTICS" && !_.isEmpty(item.source) && AppUtils.isMindDoctor(item.source.sourceFamily)).length > 0) {
            plan.diagnosticAssessmentByTherapist = patientPlan.filter(item => item.category === "DIAGNOSTICS" && AppUtils.isMindDoctor(item.source.sourceFamily)) as DiagnosticPrescriptionItemRequest[];
        }

        if (!_.isEmpty(doctorPrescription)) {
            plan.chiefComplaints = doctorPrescription.patientSymptomSet;
            plan.hopi = doctorPrescription.hopi;
            plan.diagnosis = doctorPrescription.diagnosisPrescriptionSet;
        }
        if (!_.isEmpty(therapistPrescription)) {
            plan.chiefComplaintsByTherapist = therapistPrescription.patientSymptomSet;
            plan.hopiByTherapist = therapistPrescription.hopi;
            plan.diagnosisByTherapist = therapistPrescription.diagnosisPrescriptionSet;
            plan.formulationAndSummarySet = therapistPrescription.formulationAndSummarySet;
            plan.patientNoteSet = therapistPrescription.patientNoteSet;
        }
        return plan;
    }

    static generatePlanSaveObject = (patientPlan: IPatientLifestylePlanWrapper, consultationId: number, doctorId: number, doctorType: string, doctorName: string) => {
        let plan = { ...patientPlan };
        let updatedPlan: IGenericPlanPrescriptionDetailObject[] = [];
        if (!_.isEmpty(plan.dietPrescription))
            updatedPlan = updatedPlan.concat(AppUtils.formatMealsRequest(plan.dietPrescription) as IGenericPlanPrescriptionDetailObject[]) as IGenericPlanPrescriptionDetailObject[];
        if (!_.isEmpty(plan.fitnessPrescription))
            updatedPlan = updatedPlan.concat(plan.fitnessPrescription as IGenericPlanPrescriptionDetailObject[]) as IGenericPlanPrescriptionDetailObject[];
        if (!_.isEmpty(plan.mindfulnessPrescription))
            updatedPlan = updatedPlan.concat(plan.mindfulnessPrescription as IGenericPlanPrescriptionDetailObject[]) as IGenericPlanPrescriptionDetailObject[];
        if (!_.isEmpty(plan.habitsPrescription))
            updatedPlan = updatedPlan.concat(plan.habitsPrescription as IGenericPlanPrescriptionDetailObject[]) as IGenericPlanPrescriptionDetailObject[];
        if (!_.isEmpty(plan.consultations))
            updatedPlan = updatedPlan.concat(!_.isEmpty(plan.consultations) ? plan.consultations as IGenericPlanPrescriptionDetailObject[] : [])
                .concat(!_.isEmpty(plan.consultationsByTherapist) ? plan.consultationsByTherapist as IGenericPlanPrescriptionDetailObject[] : [])
                .concat(!_.isEmpty(plan.consultationsByLifestyleCoach) ? plan.consultationsByLifestyleCoach as IGenericPlanPrescriptionDetailObject[] : []) as IGenericPlanPrescriptionDetailObject[];
        if (!_.isEmpty(plan.diagnosticAssessment))
            updatedPlan = updatedPlan.concat(!_.isEmpty(plan.diagnosticAssessment) ? plan.diagnosticAssessment as IGenericPlanPrescriptionDetailObject[] : [])
                .concat(!_.isEmpty(plan.diagnosticAssessmentByTherapist) ? plan.diagnosticAssessmentByTherapist as IGenericPlanPrescriptionDetailObject[] : []) as IGenericPlanPrescriptionDetailObject[];
        if (!_.isEmpty(plan.medicinePlanPrescription))
            updatedPlan = updatedPlan.concat(!_.isEmpty(plan.medicinePlanPrescription) ? plan.medicinePlanPrescription as IGenericPlanPrescriptionDetailObject[] : [])
                .concat(!_.isEmpty(plan.medicinePlanPrescriptionByTherapist) ? plan.medicinePlanPrescriptionByTherapist as IGenericPlanPrescriptionDetailObject[] : []) as IGenericPlanPrescriptionDetailObject[];

        let source = {
            serviceId: "DOCSAPP",
            serviceRefId: `CONS-${consultationId}`,
            userType: "DOCTOR",
            userRefId: doctorId.toString(),
            sourceFamily: AppUtils.getPlanMetaDoctorType(doctorType)
        }

        let newPrescriptionItems: IGenericPlanPrescriptionDetailObject[] = [];
        let editedPrescriptionItems: IGenericPlanPrescriptionDetailObject[] = [];
        let addedPrescriptionIds: string[] = [];
        _.map(updatedPlan, (updatedPlanItem) => {
            let newPlan = JSON.parse(JSON.stringify(updatedPlanItem));
            if (_.isEmpty(updatedPlanItem._id)) {
                if (AppUtils.isFitnessGuidelinesPrescriptionItem(newPlan)) {
                    newPlan.guidelines = AppUtils.getGuidelinesItemsWithMeta(newPlan.guidelines, consultationId, doctorId, doctorType, doctorName);
                    newPrescriptionItems.push(newPlan);
                } else {
                    newPrescriptionItems.push(updatedPlanItem);
                }
            } else {
                if (!_.isEmpty(newPlan.editInfo) && newPlan.editInfo.nextStatus === "CANCELLED") {
                    if (_.isEmpty(updatedPlanItem._id) || addedPrescriptionIds.indexOf(updatedPlanItem._id) === -1) {
                        addedPrescriptionIds.push(updatedPlanItem._id);
                        newPlan.prescriptionItemId = updatedPlanItem._id;
                        delete newPlan._id;
                        editedPrescriptionItems.push(newPlan);
                    }
                } else if (AppUtils.isFitnessGuidelinesPrescriptionItem(newPlan)) {
                    newPlan.guidelines = AppUtils.getGuidelinesItemsWithMeta(newPlan.guidelines, consultationId, doctorId, doctorType, doctorName);
                    addedPrescriptionIds.push(newPlan._id);
                    newPlan.prescriptionItemId = updatedPlanItem._id;
                    delete newPlan._id;
                    editedPrescriptionItems.push(newPlan);
                }
            }
        })

        let planSaveObject = {
            source,
            newPrescriptionItems: newPrescriptionItems,
            editedPrescriptionItems: editedPrescriptionItems
        }

        return planSaveObject;
    }

    static isFitnessGuidelinesPrescriptionItem = (planPrescriptionItem: IGenericPlanPrescriptionDetailObject) => {
        return planPrescriptionItem.onlyGuidelines && !_.isEmpty(planPrescriptionItem.guidelines)
    };

    static getGuidelinesItemsWithMeta = (guidelines: PrescriptionItemGuideline[], consultationId: number, doctorId: number, doctorType: string, doctorName: string) => {
        return guidelines.map((guideline: PrescriptionItemGuideline) => {
            if (_.isNull(guideline.meta)) {
                guideline.meta = {
                    doctorId: doctorId.toString(),
                    doctorType: AppUtils.getPlanMetaDoctorType(doctorType),
                    doctorName,
                    consultationId
                }
            }
            return guideline;
        });
    };

    static generateRedisPlanSaveObject = (patientPlan: { updatedPersonalInfo?: IPatientLifestylePlanWrapper, newConfigData: any }, consultationId: number, doctorId: number) => {
        let plan = { ...patientPlan.updatedPersonalInfo };
        let updatedPlan: any[] = [];
        // if (!_.isEmpty(plan.dietPrescription)) updatedPlan = updatedPlan.concat(AppUtils.formatMealsRequest(plan.dietPrescription));
        // if (!_.isEmpty(plan.fitnessPrescription)) updatedPlan = updatedPlan.concat(plan.fitnessPrescription);
        // if (!_.isEmpty(plan.mindfulnessPrescription)) updatedPlan = updatedPlan.concat(plan.mindfulnessPrescription);
        // if (!_.isEmpty(plan.habitsPrescription)) updatedPlan = updatedPlan.concat(plan.habitsPrescription);
        if (!_.isEmpty(plan.consultations) || !_.isEmpty(plan.consultationsByLifestyleCoach)) updatedPlan = updatedPlan.concat(!_.isEmpty(plan.consultations) ? plan.consultations : [])
            .concat(!_.isEmpty(plan.consultationsByTherapist) ? plan.consultationsByTherapist : [])
            .concat(!_.isEmpty(plan.consultationsByLifestyleCoach) ? plan.consultationsByLifestyleCoach : []) as IGenericPlanPrescriptionDetailObject[];
        if (!_.isEmpty(plan.diagnosticAssessment) || !_.isEmpty(plan.diagnosticAssessmentByTherapist)) updatedPlan = updatedPlan.concat(!_.isEmpty(plan.diagnosticAssessment) ? plan.diagnosticAssessment : [])
            .concat(!_.isEmpty(plan.diagnosticAssessmentByTherapist) ? plan.diagnosticAssessmentByTherapist : []) as IGenericPlanPrescriptionDetailObject[];
        if (!_.isEmpty(plan.medicinePlanPrescription) || !_.isEmpty(plan.medicinePlanPrescriptionByTherapist)) updatedPlan = updatedPlan.concat(!_.isEmpty(plan.medicinePlanPrescription) ? plan.medicinePlanPrescription : [])
            .concat(!_.isEmpty(plan.medicinePlanPrescriptionByTherapist) ? plan.medicinePlanPrescriptionByTherapist : []) as IGenericPlanPrescriptionDetailObject[];

        if (!_.isEmpty(plan.doctorAdvice)) {
            updatedPlan.push({
                category: "DOCTOR_ADVICE",
                doctorAdvice: plan.doctorAdvice
            });
        }
        if (!_.isEmpty(patientPlan.newConfigData)) {
            if (!_.isEmpty(patientPlan.newConfigData.dietPlan)) {
                updatedPlan.push({ category: "DIET_PLAN", dietPlan: patientPlan.newConfigData.dietPlan });
            }
            if (!_.isEmpty(patientPlan.newConfigData.healthTarget)) {
                updatedPlan.push({ category: "HEALTH_TARGET", healthTarget: patientPlan.newConfigData.healthTarget })
            }
            if (!_.isEmpty(patientPlan.newConfigData.otherGoals)) {
                updatedPlan.push({ category: "OTHER_GOALS", otherGoals: patientPlan.newConfigData.otherGoals })
            }
            if (!_.isEmpty(patientPlan.newConfigData.patient_interventions)) {
                updatedPlan.push({ category: "PATIENT_INTERVENTIONS", patient_interventions: patientPlan.newConfigData.patient_interventions })
            }
            if (!_.isEmpty(patientPlan.newConfigData.fitnessPlan)) {
                updatedPlan.push({ category: "FITNESS_PLAN", fitnessPlan: patientPlan.newConfigData.fitnessPlan })
            }
            if (!_.isEmpty(patientPlan.newConfigData.mindfulnessPlan)) {
                updatedPlan.push({
                    category: "MINDFULNESS_PLAN",
                    mindfulnessPlan: patientPlan.newConfigData.mindfulnessPlan
                })
            }
            if (!_.isEmpty(patientPlan.newConfigData.habits)) {
                updatedPlan.push({ category: "HABITS", habits: patientPlan.newConfigData.habits })
            }
            if (!_.isEmpty(patientPlan.newConfigData.prescriptionInstructions)) {
                updatedPlan.push({
                    category: "ADDITIONAL_INSTRUCTIONS",
                    prescriptionInstructions: patientPlan.newConfigData.prescriptionInstructions
                })
            }
        }

        return updatedPlan;
    }

    static generateGoalsSaveObject = (patientGoals: UserGoalView[], consultationId: number, doctorId: number) => {
        let source = {
            serviceId: "DOCSAPP",
            serviceRefId: `CONS-${consultationId}`,
            userType: "DOCTOR",
            userRefId: doctorId.toString()
        }
        return { source, userGoals: patientGoals };
    }

    static getDishIcon = (unit: string) => {
        switch (unit) {
            case "katori":
                return ORION_IMG_URL + "icons/big-bowl.svg"
            case "bowl":
                return ORION_IMG_URL + "icons/small-bowl.svg"
            case "big bowl":
                return ORION_IMG_URL + "icons/big-bowl.svg"
            case "teaspoon":
                return ORION_IMG_URL + "icons/spoon.svg"
            case "tablespoon":
                return ORION_IMG_URL + "icons/table-spoon.svg"
            case "cup":
                return ORION_IMG_URL + "icons/cup.svg"
            case "glass":
                return ORION_IMG_URL + "icons/glass.svg"
            case "piece":
                return ORION_IMG_URL + "icons/piece.svg"
            case "unit":
                return ORION_IMG_URL + "icons/piece.svg"
            case "g":
                return ORION_IMG_URL + "icons/gram.svg"
            case "ml":
                return ORION_IMG_URL + "icons/ml.svg"
            default:
                return ORION_IMG_URL + "icons/big-bowl.svg"
        }
    }

    static getSlotIcon = (slot: string) => {
        switch (slot) {
            case "PRE_BREAKFAST":
                return ORION_IMG_URL + "icons/pre-breakfast.svg"
            case "BREAKFAST":
                return ORION_IMG_URL + "icons/breakfast.svg"
            case "LUNCH":
                return ORION_IMG_URL + "icons/lunch.svg"
            case "MID_DAY_MEAL":
                return ORION_IMG_URL + "icons/mid-day-meal.svg"
            case "SNACKS":
                return ORION_IMG_URL + "icons/evening-snack.svg"
            case "PRE_WORKOUT":
                return ORION_IMG_URL + "icons/pre-workout.svg"
            case "POST_WORKOUT":
                return ORION_IMG_URL + "icons/post-workout.svg"
            case "DINNER":
                return ORION_IMG_URL + "icons/dinner.svg"
            case "EARLY_AFTERNOON_SNACK":
                return ORION_IMG_URL + "icons/early-afternoon-snack.svg"
            case "MID_MORNING_SNACK":
                return ORION_IMG_URL + "icons/mid-morning-snack.svg"
            case "LATE_EVENING_SNACK":
                return ORION_IMG_URL + "icons/late-evening-snack.svg"
            case "BEDTIME_SNACK":
                return ORION_IMG_URL + "icons/bedtime-snack.svg"
            default:
                return ORION_IMG_URL + "icons/breakfast.svg"
        }
    }

    static formatMealsRequest = (dietPrescriptions: any[]) => {
        let formattedRequest: DietPrescriptionItemRequest[] = [];
        _.map(dietPrescriptions, (dietPrescription: DietPrescriptionItemRequest) => {
            let updatedPrescriptionItem = { ...dietPrescription };
            if (!_.isEmpty(updatedPrescriptionItem.meals)) {
                let meals = [...updatedPrescriptionItem.meals];
                _.map(meals, (meal: IMealSlot) => {
                    if (!_.isEmpty(meal.details) && !_.isEmpty(meal.details.meals)) delete meal.details.meals;
                })
                updatedPrescriptionItem.meals = meals;
            }
            formattedRequest.push(updatedPrescriptionItem);
        })
        return formattedRequest;
    }

    static getValidDietPlanForPrint = (dietPrescriptions: any[]) => {
        return dietPrescriptions.filter(item => (item.status === "LIVE" && (_.isEmpty(item.editInfo) || item.editInfo.nextStatus !== "CANCELLED")) ||
            (item.status === "DRAFT" && (_.isEmpty(item.editInfo) || item.editInfo.nextStatus === "LIVE")))
    }

    static shouldOpenChatWindowForConsultation = (consultation: IAppointmentScheduleResponse, doctorId: number) => {
        return _.get(consultation, "doctor.id", null) === doctorId
            && _.get(consultation, "appointmentActionsWithContext.chatActionWithContext.action.actionPermitted", false) === true;

    }

    static isDefined = (obj: any): boolean => {
        return (obj !== null && obj !== undefined)
    }
    static isTextDefined = (obj: string) => {
        return obj !== ("undefined" || null) ? obj : "";
    }

    static getGoalIdFromGoalName = (goalId: string, staticGoals: any) => {
        let goals: any = Object.values(staticGoals);
        let goalIds = goals.map((item: any) => item._id);
        let index = goalIds.indexOf(goalId);
        if (index !== -1) return (goals[index] as any).name;
        else return "";
    }

    static getMetricNameFromMetricId = (metricId: string, staticMetrics: any) => {
        let metrics: any = Object.values(staticMetrics);
        let metricIds = metrics.map((item: any) => item.id);
        let index = metricIds.indexOf(metricId);
        if (index !== -1) return (metrics[index] as any).name;
        else return "";
    }

    static getLabTestConditionFromValue = (condition: string): IStaticDataValue => {
        let internalValue = Object.keys(AppConstants.LabtestConditions).filter(key => AppConstants.LabtestConditions[key] === condition)[0];
        return {
            displayValue: condition,
            internalValue
        }
    }

    static getPlanMetaDoctorType = (doctorType: string) => {
        let metaDoctorType = "DOCTOR";
        if (doctorType === "MIND_THERAPIST") metaDoctorType = "THERAPIST";
        else if (doctorType === "LC") metaDoctorType = "LIFESTYLE";
        return metaDoctorType;
    }

    static getPolarisUserId = (patientId: number, curefitUserId: number, isSelf: boolean): string => {
        let polarisUserId = curefitUserId.toString();
        if (!isSelf) {
            polarisUserId = polarisUserId.concat(`-${patientId}`);
        }
        return polarisUserId;
    }

    static getFrequencyText = (frequency: IFitnessSchedule, isFrequency?: boolean) => {
        let count = !_.isEmpty(frequency) && frequency.count !== null ? frequency.count : null;
        let countText = "";
        if (count === 1) countText = "Once";
        else if (count === 2) countText = "Twice";
        else countText = `${count} times`;
        let unit = !_.isEmpty(frequency) && !_.isEmpty(frequency.unit) ? frequency.unit : null;
        let repitition = !_.isEmpty(frequency) && !_.isEmpty(frequency.repetition) && frequency.repetition.count !== undefined && frequency.repetition.count !== null ? frequency.repetition.count : "";
        let frequencyText = "";
        if (!_.isNull(count) && !_.isNull(unit) && !_.isNull(count)) {
            if (isFrequency === undefined || isFrequency)
                frequencyText = `${countText} every ${repitition !== 1 ? repitition + " " : ""}${AppConstants.FrequencyUnit[unit].toLowerCase()}${repitition > 1 ? "s" : ""}`;
            else
                frequencyText = `${count} ${AppConstants.FrequencyUnit[unit].toLowerCase()}${count > 1 ? "s" : ""}`;
        }
        return frequencyText;
    }

    static getAlbusFrequencyText = (frequency: IFrequency, isFrequency?: boolean, preferredSeparator?: string): string => {
        let count = !_.isEmpty(frequency) && frequency.count !== null && frequency.count !== undefined ? frequency.count : null;
        let unit = !_.isEmpty(frequency) && !_.isEmpty(frequency.unit) ? frequency.unit : null;
        let separator = !_.isEmpty(preferredSeparator) ? preferredSeparator : "/";
        let frequencyText = "";
        if (!_.isNull(count) && !_.isNull(unit)) {
            if (isFrequency === undefined || isFrequency)
                frequencyText = `${count} ${separator} ${AppConstants.FrequencyUnit[unit].toLowerCase()}${count > 1 ? "s" : ""}`;
            else
                frequencyText = `${count} ${AppConstants.FrequencyUnit[unit].toLowerCase()}${count > 1 ? "s" : ""}`;
        }
        return frequencyText;
    }

    static getDeepCopiedObject = (obj: any) => {
        return JSON.parse(JSON.stringify(obj));
    }

    static calculateNumberOfDaysFromDuration = (unit: string, count: number) => {
        let computedCount = 0;
        if (unit === "DAY") {
            computedCount = count;
        } else if (unit === "WEEK") {
            computedCount = count * 7;
        } else if (unit === "MONTH") {
            computedCount = count * 30;
        } else if (unit === "YEAR") {
            computedCount = count * 365;
        }
        return computedCount;
    }

    static getAssessmentLink = (metricObj: IAddMetric, userId: number, isSelf: boolean, subUserId: number): string => {
        let assessmentLink = null;
        let assessmentUrl = `${CFS_API_ENDPOINT_HOST}/#/assessment?userId=$userId&isSelf=$isSelf&subUserId=$subUserId&formId=$formId`;
        if (!_.isEmpty(metricObj) && !_.isEmpty(metricObj.measureMeta) && metricObj.measureMeta.isAssessmentEnabled) {
            let formId = metricObj.measureMeta.assessmentFormId;
            assessmentLink = assessmentUrl.replace("$userId", userId.toString()).replace("$isSelf", isSelf.toString()).replace("$subUserId", subUserId.toString()).replace("$formId", formId);
        }
        return assessmentLink;
    }

    static checkIntegrityOfConsultation = (ongoingConsultation: IOngoingConsultation, patientId: number, appointmentId: number) => {
        let integrity = false;
        if (_.isEmpty(ongoingConsultation) ||
            (!_.isEmpty(ongoingConsultation.appointmentSchedule) && ongoingConsultation.appointmentSchedule.id.toString() === appointmentId.toString() &&
                ongoingConsultation.appointmentSchedule.patient.id.toString() === patientId.toString())) integrity = true;
        return integrity;
    }

    static shouldPrescriptionItemDisplayInPDF = (prescriptionItem: BasePrescriptionItemRequest | IPrescriptionMedication) => {
        let flag = false;
        /* for a PLI to appear in the PDF,
         * i)  it's status shouldn't be CANCELLED
         * ii) It shouldn't contain a property called isDefaultExpiry, but if it does, then:
         *      - it should be set to true or
         *      - current epoch should be greater than the endEpoch of PLI
         */
        if ((prescriptionItem as any).status !== "CANCELLED" &&
            (!prescriptionItem.hasOwnProperty("isDefaultExpiry") ||
                ((prescriptionItem as any).isDefaultExpiry || (prescriptionItem as any).endEpoch > new Date().getTime())))
            flag = true;
        return flag;
    }

    static convertMedicineDosageToText = (value: number) => {
        let textValue = value.toString();
        switch (value) {
            case 1:
                textValue = "once";
                break;
            case 2:
                textValue = "twice";
                break;
            case 3:
                textValue = "thrice";
                break;
        }
        return textValue;
    }

    static isMindDoctor = (doctorType: string) => {
        return !_.isEmpty(doctorType) && (doctorType === AppConstants.MPDoctorTypes.THERAPIST)
    }

    static getAgeToDisplay = (age: IFormattedAge): string => {
        return !_.isEmpty(age) && AppUtils.isDefined(age.numOfYears) && age.numOfYears > 0 ? age.numOfYears.toString() : "";
    }

    static getFormattedAgeToDisplay = (age: IFormattedAge): string => {
        let ageToReturn = "";
        if (!_.isEmpty(age) && AppUtils.isDefined(age.numOfYears) && age.numOfYears > 0) {
            let years = age.numOfYears;
            let months = AppUtils.isDefined(age.numOfMonths) && !isNaN(Number(age.numOfMonths)) ? age.numOfMonths : null;
            let roundedMonths = !_.isNull(age.numOfMonths) && AppUtils.isDefined(age.numOfDays) && age.numOfDays >= 15 ? months + 1 : months;
            ageToReturn = `${years} ${years === 1 ? "year" : "years"}${!_.isNull(roundedMonths) ? ` ${roundedMonths} ${roundedMonths === 1 ? "month" : "months"}` : ""}`;
            if (years < 5) {
                let days = AppUtils.isDefined(age.numOfDays) ? age.numOfDays : null;
                ageToReturn = `${years} ${years === 1 ? "year" : "years"}${!_.isNull(months) ? ` ${months} ${months === 1 ? "month" : "months"}` : ""}${!_.isNull(days) ? ` ${days} ${days === 1 ? "day" : "days"}` : ""}`;
            }
        } else if (!_.isEmpty(age) && AppUtils.isDefined(age.numOfMonths) && age.numOfMonths > 0) {
            let months = age.numOfMonths;
            let days = AppUtils.isDefined(age.numOfDays) ? age.numOfDays : null;
            ageToReturn = `${months} ${months === 1 ? "month" : "months"}${!_.isNull(days) ? ` ${days} ${days === 1 ? "day" : "days"}` : ""}`;
        } else if (!_.isEmpty(age) && AppUtils.isDefined(age.numOfDays)) {
            ageToReturn = `${age.numOfDays} ${age.numOfDays === 1 ? "day" : "days"}`;
        }
        return ageToReturn;
    }

    static sanitizeDietRecallRequest = (dietRecall: any) => {
        const dietRecallV1Keys = Object.keys(dietRecall).filter(key => key.substring(key.length - 2, key.length) === "v1");
        dietRecallV1Keys.forEach(key => {
            delete dietRecall[key.substring(0, key.length - 2)]
        })
        return dietRecall;
    }

    static isPhysiotherapist = (doctorType: string) => {
        return doctorType === "PHYSIOTHERAPIST";
    }

    static isPhysiotherapistConsultation = (consultation: IAppointmentScheduleResponse) => {
        return AppUtils.isPhysiotherapist(consultation.consultationProduct.subServiceType);
    }

    static getAllMealIds(result: any): string[] {
        let allMealIds: string[] = [];
        _.map(result, (adherence) => {
            if (!_.isEmpty(adherence)) {
                let dietSection = _.filter(adherence, (item) => item.category === "FOOD" && !_.isEmpty(item.recommendationAdherenceDetails));
                _.map((dietSection), (dietSectionItem) => {
                    if (!_.isEmpty(dietSectionItem.recommendationAdherenceDetails)) {
                        _.map(dietSectionItem.recommendationAdherenceDetails, (dietItem) => {
                            if (!_.isEmpty(dietItem.recommendedActivity) && !_.isEmpty(dietItem.recommendedActivity.details) && !_.isEmpty(dietItem.recommendedActivity.details.mealIds)) {
                                allMealIds = allMealIds.concat(dietItem.recommendedActivity.details.mealIds);
                            }
                        })
                    }
                })
            }
        });
        return allMealIds;
    }

    static getAllLoggedActivityIds(result: any): string[] {
        let allActivityIds: string[] = [];
        _.map(result, (adherence) => {
            if (!_.isEmpty(adherence)) {
                let dietSection = _.filter(adherence, (item) => ((item.category === "FOOD" || item.category === "FITNESS" || item.category === "MIND") && !_.isEmpty(item.recommendationAdherenceDetails)));
                _.map((dietSection), (dietSectionItem) => {
                    _.map(dietSectionItem.recommendationAdherenceDetails, (dietItem) => {
                        if (!_.isEmpty(dietItem.loggedActivity) && !_.isEmpty(dietItem.loggedActivity[0].activityID)) {
                            allActivityIds = allActivityIds.concat(dietItem.loggedActivity[0].activityID);
                        }
                    })
                })
            }
        });
        return allActivityIds;
    }

    static sanitizeUserProfileResponse(userProfile: PatientPersonalProfile) {
        let sanitizedUserProfile = { ...userProfile };
        if (!_.isEmpty(userProfile.dietRecall) && !_.isEmpty(userProfile.dietRecall.preferredCuisinesv1) &&
            !_.isEmpty(userProfile.dietRecall.preferredCuisinesv1.value)) {
            userProfile.dietRecall.preferredCuisinesv1.value = _.uniqBy(userProfile.dietRecall.preferredCuisinesv1.value, "displayValue");
        }
        if (!_.isEmpty(userProfile.dietRecall) && !_.isEmpty(userProfile.dietRecall.preferredCuisinesv1) &&
            !_.isEmpty(userProfile.dietRecall.preferredFoodTypesv1.value)) {
            userProfile.dietRecall.preferredFoodTypesv1.value = _.uniqBy(userProfile.dietRecall.preferredFoodTypesv1.value, "displayValue");
        }
        return sanitizedUserProfile;
    }

    static getRequiredGoalMilestonesDate(startDate: number, addMonthValue: number) {
        return moment(startDate).add(addMonthValue, "M").valueOf();
    }

    static getRequiredGoalMilestoneDayEpoch(startDate: number, addMonthValue: number, dayEvent?: "START" | "END") {
        const currentEpoch = AppUtils.getRequiredGoalMilestonesDate(startDate, addMonthValue);
        if (!AppUtils.isDefined(dayEvent)) {
            return currentEpoch
        } else {
            if (dayEvent === "START") {
                return AppUtils.getStartOFDayEpoch(currentEpoch);
            } else if (dayEvent === "END") {
                return AppUtils.getEndOFDayEpoch(currentEpoch);
            }
        }
    }

    /* Last week's Sunday epoch (if day of week starts with sunday) */
    static getLastWeekStartDayEpoch(unixTimeEpoch: number) {
        return moment(unixTimeEpoch).set("day", -7).startOf("day").valueOf()
    }

    /* Last week's Saturday epoch (if day of week starts with sunday) */
    static getLastWeekLastDayEpoch(unixTimeEpoch: number) {
        return moment(unixTimeEpoch).set("day", -1).startOf("day").valueOf()
    }

    /* Next week's Sunday epoch (if day of week starts with sunday) */
    static getNextWeekStartDayEpoch(unixTimeEpoch: number) {
        return moment(unixTimeEpoch).set("day", 7).startOf("day").valueOf()
    }

    /* Next week's Saturday epoch (if day of week starts with sunday) */
    static getNextWeekLastDayEpoch(unixTimeEpoch: number) {
        return moment(unixTimeEpoch).set("day", 13).startOf("day").valueOf()
    }

    static getRelativeMonthDetails(epoch: number, forward: boolean, isCurrent: boolean) {
        const relativeMonthMoment = moment(epoch).subtract(forward ? -1 : isCurrent ? 0 : 1, "month")
        const monthStartDate = relativeMonthMoment.startOf("month").valueOf();
        const monthEndDate = relativeMonthMoment.endOf("month").valueOf();
        return {
            startDate: monthStartDate,
            endDate: monthEndDate,
            monthString: relativeMonthMoment.format("MMMM")
        }
    }

    static getWorkflowFailureError(workflow: IWorkflowState[]) {
        let errorMsg = null;
        if (!_.isEmpty(workflow)) {
            const failureState = workflow.find((stateItem: IWorkflowState) => AppUtils.isDefined(stateItem) && stateItem.state === WorkflowStates.FAILED);
            if (!_.isEmpty(failureState)) {
                if (!_.isEmpty(failureState.actionResultInfo) && failureState.actionResultInfo[0].errorObject && failureState.actionResultInfo[0].errorObject.message) {
                    errorMsg = failureState.actionResultInfo[0].errorObject.message;
                } else if (failureState.message) {
                    errorMsg = failureState.message
                }
            }
        }
        return errorMsg;
    }

    static isPatientRelationSelf(detail: IPatientDetail) {
        return detail.relationship === AppConstants.PatientRelationshipConstant.SELF.displayValue
    }

    // static convertObjectIntoQueryParams(obj: any) {
    //     if (obj === undefined || obj == null) {
    //       return "";
    //     }
    //     return ("?" +
    //       Object.keys(obj).reduce((a: any[], k: string) => {
    //           a.push(`${k}=${encodeURIComponent(obj[k])}`);
    //           return a;
    //         }, [])
    //         .join("&")
    //     );
    //   }

    static containsOnlyAsciiChar(str: string | number) {
        return /^[\000-\177]*$/.test((str || "").toString())
    }

    static getSpecialCharacters(str: string) {
        return [...str].filter(char => !AppUtils.containsOnlyAsciiChar(char)).join(", ")
    }

    static getNonSpecialCharString(str: string) {
        str = str.toString();
        return str.replace(/[^\x20-\x7E \n]|/g, "");
    }

    static isExpiredPLI(prescriptionItem: BasePrescriptionItemRequest) {
        return prescriptionItem._id && prescriptionItem.endEpoch && prescriptionItem.endEpoch < new Date().getTime();
    }

    static logout() {
        // const cookies = document.cookie.split(";");
        //
        // for (let i = 0; i < cookies.length; i++) {
        //     const cookie = cookies[i];
        //     const eqPos = cookie.indexOf("=");
        //     const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        //     document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        // }
        //
        // window.open("/", "_self");
        window.location.pathname = "/logout";
    }

    static getPatientPrimaryGoals(goals: UserGoalView[]) {
        return !_.isEmpty(goals) ? goals.filter(goal => goal.userGoalType === "PRIMARY") : [];
    }

    static getNonActiveMetricIdsForGoals(patientGoals: UserGoalView[], patientMetrics: { [metricId: number]: IMetricData[] }): number[] {
        const metricIds: number[] = [];
        if (!_.isEmpty(patientGoals)) {
            patientGoals.map(goal => {
                if (!_.isEmpty(goal.goalMetricTargets)) {
                    goal.goalMetricTargets.map(metric => {
                        let { metricId } = metric;
                        if (!AppUtils.isDefined(patientMetrics) || !AppUtils.isDefined(patientMetrics[metricId as any])) {
                            metricIds.push(metricId);
                        }
                    });
                }
            });
        }
        return metricIds
    }

    /**
     * Converts the passed date to formatted date
     * using moment
     */
    static getMomentFormattedDate(date?: any) {
        const formattedDate = AppUtils.isDefined(date) ? moment(date).utc().format() : moment().utc().format();
        return formattedDate;
    }

    static getPainScale() {
        let painScale = [];
        for (let i = 0; i <= AppConstants.PAIN_SCALE_MAX_VALUE; i++) {
            painScale.push(i);
        }
        return painScale;

    }

    static getTabWidget = (uiConfiguration: any[], tabname: string) => {
        return uiConfiguration.filter((widget: any) => widget.sectionKey === tabname)
    }


    static getColorConsole = (size: number = null, color: string = null, text: any) => {
        let random = ((1 << 24) * Math.random() | 0).toString(16);
        if (!color) color = "#" + random;
        if (!size) size = 15;

        console.log(`%c ${text} `, `color: ${color}; font-size:${size}px`);
    }
    /**
     *
     * @param Dataset  medical profile for the patient
     * @param dataStatusFlag  which data we want to Show
     * @param subsectionKey  data to retrive for the subsection
     */



    static consultationDataDecider = (Dataset: any, dataStatusFlag: boolean = false, subSectionKey: any) => {

        /**
         * Local Variable Defination START
         */
        const OLDCONSULATION = ConfigConstants.OLDCONSULTATION;
        const CURRENTCONSULATION = ConfigConstants.CURRENTCONSULTATION;
        const sectionName = dataStatusFlag ? CURRENTCONSULATION : OLDCONSULATION;
        /**
         * Local Variable Defination START
         * END
         */
        // let sendDataObj = Dataset[CURRENTCONSULATION][subSectionKey] || {};
        // return sendDataObj|| {};

        if (sectionName === OLDCONSULATION) {

            let sendDataObj = _.merge({}, Dataset[sectionName][subSectionKey], Dataset[CURRENTCONSULATION][subSectionKey]);
            return sendDataObj || {};
        } else {
            let sendDataObj = Dataset[CURRENTCONSULATION][subSectionKey] || {};
            return sendDataObj || {};
        }

    }

    static setPdfTemplatesIdToNameMap = (constituentTemplates: IConstituentTemplate[]) => {
        let idToNameMap: { [key: string]: string } = {};
        if (!_.isEmpty(constituentTemplates)) {
            constituentTemplates.forEach((template: IConstituentTemplate) => {
                idToNameMap[template.id] = template.name;
            });
        }
        return idToNameMap;
    }

    static setPdfTemplateNameToDataMap = (constituentTemplates: IConstituentTemplate[]) => {
        let nameToDataMap: { [key: string]: string } = {};
        if (!_.isEmpty(constituentTemplates)) {
            constituentTemplates.forEach((template: IConstituentTemplate) => {
                nameToDataMap[template.name] = template.data;
            });
        }
        return nameToDataMap;
    }

    static copyTextToClipboard = (text: string): Promise<any> => {
        return new Promise((resolve, reject) => {
            let textArea = document.createElement("textarea");
            textArea.value = text;
            textArea.style.position = "fixed";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                const success = document.execCommand("copy");
                if (success) {
                    document.body.removeChild(textArea);
                    resolve({
                        isSuccess: success,
                        data: text
                    })
                } else {
                    document.body.removeChild(textArea);
                    reject({
                        isSuccess: success,
                        data: null
                    })
                }
            } catch (err) {
                document.body.removeChild(textArea);
                reject({
                    isSuccess: false,
                    data: err
                })
            }
        })
    }

    static isActionAllowedForConsultation = (consultation: IAppointmentScheduleResponse) => {
        return !_.isEmpty(consultation) && !_.isEmpty(consultation.availableDoctorActions);
    }

    static isStartActionAllowedForConsultation = (consultation: IAppointmentScheduleResponse) => {
        return AppUtils.isActionAllowedForConsultation(consultation) && consultation.availableDoctorActions.indexOf(ALLOWED_ACTIONS.START_CONSULTATION) > -1;
    }

    static isSuggestionComponent = (question: any) => {
        return !_.isEmpty(question) && !_.isEmpty(question.answerList) && question.answerList[0].type && question.answerList[0].type === QuestionType.SUGGESTION
    }

    static parseRosterDataWithBreaksToWIthoutBreaks(data: IResourceSchedule[]): IResourceSchedule[] {
        const parsedData: IResourceSchedule[] = [];
        data = data.filter(({ availableOnline }) => availableOnline);
        data.forEach((shift: IResourceSchedule) => {
            shift.resourceDeallocationScheduleList = shift.resourceDeallocationScheduleList.filter(({ scheduleStatus }) => scheduleStatus === SHIFT_STATUS.ACTIVE)
            if (shift.resourceDeallocationScheduleList.length === 0) {
                parsedData.push(shift); // when no deallocations present
            } else {
                const { workingDayDate, startTime, endTime } = shift
                const workStartTimeEpoch: number = AppUtils.getEpochFromDateAndTime(workingDayDate, startTime);
                const workEndTimeEpoch: number = AppUtils.getEpochFromDateAndTime(workingDayDate, endTime);

                for (let breakCount = 0; breakCount <= shift.resourceDeallocationScheduleList.length; breakCount++) {
                    const deallocation = shift.resourceDeallocationScheduleList[breakCount];
                    let actualStartEpoch: number;
                    let actualEndEpoch: number;
                    if (breakCount === 0) {
                        actualStartEpoch = workStartTimeEpoch;
                    } else {
                        const previousBreakEndTime = shift.resourceDeallocationScheduleList[breakCount - 1].endTime;
                        actualStartEpoch = AppUtils.getEpochFromDateAndTime(workingDayDate, previousBreakEndTime);
                    }

                    if (breakCount === shift.resourceDeallocationScheduleList.length) {
                        actualEndEpoch = workEndTimeEpoch;
                    } else {
                        const nextBreakStartTime = shift.resourceDeallocationScheduleList[breakCount].startTime;
                        actualEndEpoch = AppUtils.getEpochFromDateAndTime(workingDayDate, nextBreakStartTime);
                    }
                    if (actualStartEpoch != actualEndEpoch) {
                        parsedData.push({
                            ...shift,
                            startTime: moment(actualStartEpoch).format("HH:mm"),
                            endTime: moment(actualEndEpoch).format("HH:mm"),
                            isSplitShift: true
                        })
                    }
                }
            }
        })
        return parsedData;
    }

    static isTeleConsultationAppointment(appointment: IAppointmentScheduleResponse) {
        return appointment.consultationProduct.consultationMode === AppConstants.ConsultationModes.ONLINE.id
    }

    static formatStrongTag(htmlString: string) {
        return (htmlString || "").replace(/<strong/g, "<strong style='font-family:  BrandonTextWeb-Bold'")
    }

    static closeChatContainer() {
        const chatContainer = document.querySelector(".chat-container-content")
        if (!_.isEmpty(chatContainer)) {
            chatContainer.classList.add("collapsed")
        }
    }

    static getConsultationIdFromOngoingUrl(): string {
        let consultationId = "";
        if (window.location.href.includes("ongoing")) {
            const urlParts = window.location.href.split("/");
            consultationId = urlParts[urlParts.length - 2];
        }
        return consultationId;
    }

    static getNetInfo() {
        if ((navigator as any).connection) {

            const connection = (navigator as any).connection;


            return JSON.stringify({
                ram: connection.deviceMemory,
                effectiveType: connection.effectiveType,
                rtt: connection.rtt,
                downlink: connection.downlink,
                saveData: connection.saveData
            });
        }
    }

    static getMediaDevices() {
        return new Promise((resolve, reject) => {
            if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
                console.log("enumerateDevices() not supported.");
                reject("enumerateDevices() not supported.");
            }

            // List cameras and microphones.
            navigator.mediaDevices.enumerateDevices()
                .then(function (devices) {
                    const availableDevices: any[] = [];
                    _.uniqBy(devices, "deviceId").forEach(function (device: any) {
                        const { label, kind } = device;
                        availableDevices.push({ label, kind });
                    });

                    resolve(JSON.stringify(_.uniqBy(availableDevices, "kind")));
                })
                .catch(function (err) {
                    console.log(err.name + ": " + err.message);
                    reject(`${err.name}: ${err.message}`)
                });
        })

    }

    static triggerToastNotification(message: string, appearance?: toastNotificationAppearance) {
        document.dispatchEvent(new CustomEvent("showNotification", {
            detail: {
                message,
                config: { appearance }
            }
        }))
    }

    static mergeCustomizer = (objValue: any, srcValue: any) => {
        if (Array.isArray(objValue)) {
            if (_.isEqual(objValue, srcValue)) {
                return objValue;
            }
            return objValue.concat(srcValue);
        }
    }

    static urlBase64ToUint8Array(base64String: string) {
        const padding = "=".repeat((4 - base64String.length % 4) % 4);
        const base64 = (base64String + padding)
            .replace(/\-/g, "+")
            .replace(/_/g, "/");

        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);

        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }

    static getDivVisibleHeight(event: any): number {
        const elmnt = event.target,
            elTop = elmnt.offsetTop,
            elBottom = elTop + elmnt.offsetHeight
        return elBottom
    }

    static getCurrentScrollPosition(event: any): number {
        const elmnt = event.target,
            scrollTop = elmnt.scrollTop,
            elTop = elmnt.offsetTop,
            visibleTop = elTop < scrollTop ? scrollTop : elTop;
        return visibleTop
    }

    public static shouldWidgetRender = (widgetData: any, featureConfigInfo: IFeatureConfig): boolean => {
        let isRendered = false
        if (widgetData.FeatureConfigHide) {
            const flag: boolean = featureConfigInfo[widgetData.FeatureConfigHide.key] === FeatureConfigValues.TRUE
            const mobileFlag: boolean = widgetData.FeatureConfigHide.allowedOnMobile
            isRendered = (flag && (AppUtils.getIsMobile() ? mobileFlag : true))
        } else {
            isRendered = true
        }
        return isRendered
    }

    static getCurrentTime = (): number => {
        return new Date().getTime()
    }

    /**
    * updatePageLoadEvent: Used to log page Load instrument with page load time
    * */

    static updatePageLoadEvent = (flow: string, section: string, loadStartTime: number, metaParams?: { source: string, medium: string }) => {
        const pageLoadTime = AppUtils.getCurrentTime()
        const loadTimeInSec = ((pageLoadTime - loadStartTime) / 1000).toFixed(3)
        Tracker.track(EventNames.Page_Load, { flow: flow, section: section, loadTime: Number(loadTimeInSec), ...metaParams })
    }

    static getPrescriptionTabUIConfig = (doctorType?: string, uiConfiguration?: any[]) => {
        let prescriptionWidgets = [...testWidgets];
        if (doctorType && doctorType === DoctorType.AYURVEDA) {
            return prescriptionWidgets.map((widget: any) => {
                if (widget.subSectionKey === "prescriptionDiagnosis" || widget.subSectionKey === "prescriptionMedicines") {
                    widget.data[0].answerList[0].defaultItemFields.map((defaultItem: any) => {
                        if (defaultItem.type === "TYPEAHEAD") {
                            if (defaultItem?.typeAheadConfiguration?.additionalParams) {
                                defaultItem.typeAheadConfiguration.additionalParams["category"] = "AYURVEDA"
                            } else {
                                defaultItem.typeAheadConfiguration.additionalParams = { category: "AYURVEDA" }
                            }
                        }
                        return defaultItem
                    })
                }
                return widget;
            })
        } else {
            if (uiConfiguration && uiConfiguration.length) { //handle overrides example: reason for visit for couples therapy
                let overrideConfs = uiConfiguration.filter((conf: any) => conf.shouldOverRideUiConf);
                if (overrideConfs && overrideConfs.length) {
                    overrideConfs.forEach((overrideConf: any) => {
                        let confToReplaceIndex = prescriptionWidgets.findIndex((widget: any) => widget.subSectionKey === overrideConf.subSectionKey);
                        if (confToReplaceIndex >= 0) {
                            prescriptionWidgets[confToReplaceIndex] = overrideConf;
                        }
                    })
                }
            }
            return prescriptionWidgets
        }
    }

    static getFlowContextFromUrl = () => {
        const currentPage = window.location.pathname;
        if (currentPage.indexOf("consultations") > 0) {
            return EventNames.ConsultationDetails
        }
        else if (currentPage.indexOf("myPatients") > 0) {
            return EventNames.My_Patients
        }
        else if (currentPage.indexOf("ongoing") > 0) {
            return EventNames.OngoingConsultation
        }
        else if (currentPage.indexOf("roster") > 0) {
            return EventNames.Working_Hours
        }
        else if (currentPage.indexOf("treatmentPlans") > 0) {
            return EventNames.Treatment_Plan
        }
        else if (currentPage.indexOf("dashboard") > 0) {
            return EventNames.Calendar
        }
        else if (currentPage.indexOf("profile") > 0) {
            return EventNames.Profile
        }
        else if (currentPage.indexOf("patient") > 0) {
            return EventNames.My_Patients
        }
    }

    static getRecommendationTagLabel(labelKey: string, listItem: any): string {
        return labelKey ? listItem[labelKey] : listItem.displayValue;
    }

    static getStartOfTheWeekFromMonday(date: Date) {
        let currDayOfTheWeek = date.getDay();
        let numOfDaysFromMonday = currDayOfTheWeek === 0 ? 6 : currDayOfTheWeek - 1;
        let mondayEpoch = date.getTime() - numOfDaysFromMonday * EpochConstants.EPOCH_IN_AN_DAY;
        return mondayEpoch;
    }

    static getEndOfTheWeek(date: Date) {
        let currDayOfTheWeek = date.getDay();
        let numOfDaysFromSunday = currDayOfTheWeek === 0 ? 0 : (6 - currDayOfTheWeek + 1);
        let sundayEpoch = date.getTime() + numOfDaysFromSunday * EpochConstants.EPOCH_IN_AN_DAY;
        return sundayEpoch;
    }

    static get12HourFormatFrom24Hour(time: string): string {
        return moment(time, ["HH:mm"]).format("h:mm A");
    }

    static getDateFromNumberOfDays(numOfDays: number = 14) {
        return moment(new Date()).add(numOfDays, "days").format("DD MMM, YYYY");
    }

    static shouldRenderMarkDelay(appStatus: string): boolean {
        // return appStatus === ConsultationStatusConstant.SCHEDULED
        return false
    }

    static checkForTransformCoach(doctorSubServiceTypes: any[]) {
        return doctorSubServiceTypes.find(({ subServiceType }) => subServiceType.code === "TRANSFORM_COACH")
    }
    static getFormattedShortDate(dateEpoch: number) {
        return moment(dateEpoch).format("DD'MMM'YY");
    }

    static getEpochInUTC = (dateEpoch: number): number => {
        const start = new Date(dateEpoch);
        start.setHours(0, 0, 0, 0);
        let utcStartTime = Date.UTC(
            start.getFullYear(),
            start.getMonth(),
            start.getDate()
        );
        return utcStartTime;
    };

    static renderConfidentialData(): boolean {
        const data: { roleName: string }[] = reduxStore?.getState()?.accountData?.roles.filter((data : { roleName: string }) =>  [UserRoles.DOCTOR, UserRoles.NURSE].includes(data.roleName as any));
        console.log(reduxStore?.getState()?.accountData);
        return data.length != 0;
    }
}

export function scrollElementToTop(element: HTMLElement, containerElement: HTMLElement | Window, topPadding?: number, threshold?: number, onScrollDoneCb?: () => void): void {
    topPadding = topPadding === undefined ? 20 : topPadding;
    const elementOffsetTop = element.getBoundingClientRect().top;
    if (Math.abs(elementOffsetTop) > (threshold === undefined ? 200 : threshold) && containerElement) {
        const scrollAmount = elementOffsetTop - topPadding;
        easyScroll({
            scrollableDomEle: containerElement,
            direction: scrollAmount < 0 ? "top" : "bottom",
            duration: 800,
            easingPreset: "easeInQuad",
            scrollAmount: Math.abs(scrollAmount),
            onAnimationCompleteCallback: onScrollDoneCb
        });
    }
}

export function removeFieldsForId(currentPrescription: INewConfigData | IEHRSavePatientMedicalProfile, id: string): any {
    // prescriptionAdvice (advice), prescriptionLabTest (labTestList), prescriptionReferral(referral), prescriptionMedicines (prescriptionMedicationList), prescriptionFollowUp (followup)

    if (currentPrescription) {
        let newCurrentPrescription: INewConfigData = {
            ...currentPrescription,
            prescriptionAdvice: currentPrescription.prescriptionAdvice,
            prescriptionLabTest: currentPrescription.prescriptionLabTest,
            prescriptionReferral: currentPrescription.prescriptionReferral,
            prescriptionMedicines: currentPrescription.prescriptionMedicines,
            prescriptionFollowUp: currentPrescription.prescriptionFollowUp
        };

        let advices = [];
        let followup = {};
        let labTests = [];
        let referrals = [];
        let medicines = [];

        if (_get(currentPrescription, "prescriptionAdvice.advice") && currentPrescription.prescriptionAdvice.advice.length > 0) {
            advices = currentPrescription.prescriptionAdvice.advice.filter((advice: any) => {
                return advice.templateId !== id;
            });
            newCurrentPrescription.prescriptionAdvice = {
                // ...newCurrentPrescription.prescriptionAdvice,
                advice: advices
            }
        }

        if (_get(currentPrescription, "prescriptionLabTest.labTestList") && currentPrescription.prescriptionLabTest.labTestList.length > 0) {
            labTests = currentPrescription.prescriptionLabTest.labTestList.filter((labTest: any) => {
                return labTest.templateId !== id;
            });

            newCurrentPrescription.prescriptionLabTest = {
                // ...newCurrentPrescription.prescriptionLabTest,
                labTestList: labTests
            }
        }

        if (_get(currentPrescription, "prescriptionMedicines.prescriptionMedicationList") && currentPrescription.prescriptionMedicines.prescriptionMedicationList.length > 0) {
            medicines = currentPrescription.prescriptionMedicines.prescriptionMedicationList.filter((medicine: any) => {
                return medicine.templateId !== id;
            });

            newCurrentPrescription.prescriptionMedicines = {
                // ...newCurrentPrescription.prescriptionMedicines,
                prescriptionMedicationList: medicines
            }
        }

        if (_get(currentPrescription, "prescriptionReferral.referral") && currentPrescription.prescriptionReferral.referral.length > 0) {
            referrals = currentPrescription.prescriptionReferral.referral.filter((referral: any) => {
                return referral.templateId !== id;
            });

            newCurrentPrescription.prescriptionReferral = {
                // ...newCurrentPrescription.prescriptionReferral,
                referral: referrals
            }
        }

        if (_get(currentPrescription, "prescriptionFollowUp.followup")) {
            if (currentPrescription.prescriptionFollowUp.followup.templateId === id) {
                followup = {}
            }

            newCurrentPrescription.prescriptionFollowUp = {
                // ...newCurrentPrescription.prescriptionFollowUp,
                followup: followup
            }

        }

        return newCurrentPrescription;

    }
}
